import combineReducers from 'react-combine-reducers';
import {actionTypes as optionsActionTypes, rnConsensus, rnFC, roConsensus} from '../actions/options';
// import { actionTypes as teamsActionTypes } from '../actions/teams';
import { actionTypes as statusActionTypes } from '../actions/status';
import { actionTypes as modalActionTypes } from '../actions/modal';
import { actionTypes as playersActionTypes } from '../actions/players';
import teamData from '../data/teamsByYear';
import { getTeamLogo } from '../lib';

const optionsInitialState = {
    year: '2025',
    rankings: 'FC',
    rankingTitle: 'RANK',
    playerPostfix: '',
    totalRounds: 1,
    speed: 1000,
    selectedTeams: [

    ],
};

export const optionsReducer = function(state, action){
    switch(action.type){
        case optionsActionTypes.setDraftYear:
            let selectedTeams = [];
            if(action.year !== '2025'){
                selectedTeams = teamData[action.year].map((x) => x.code);
            }
            return {...state, year: action.year, selectedTeams}
        case optionsActionTypes.setRankings:
            const rankingTitle = action.ranking === roConsensus ? rnConsensus : rnFC;
            const playerPostfix = action.ranking === roConsensus ? '-consensus' : '';
            return {...state, rankings: action.ranking, rankingTitle: rankingTitle, playerPostfix: playerPostfix }
        case optionsActionTypes.setNumberOfRounds:
            return {...state, totalRounds: action.rounds}
        case optionsActionTypes.setDraftSpeed:
            return {...state, speed: action.speed}
        case optionsActionTypes.setRoundFilter:
            return {...state, roundFilter: action.round}

        case optionsActionTypes.selectTeam:
                return {...state, selectedTeams: [...state.selectedTeams, action.code]}
        case optionsActionTypes.deselectTeam:
                return {...state, selectedTeams: state.selectedTeams.filter(id => id !== action.code) }
        case optionsActionTypes.selectAllTeams:
                return {...state, selectedTeams: [...action.codes] }
        case optionsActionTypes.deselectAllTeams:
                return {...state, selectedTeams: []}
        case statusActionTypes.restartDraft:
            return {...optionsInitialState}
        default:
            return state;
    }
}


const statusInitialState = {
    step: 1,
    running: false,
    currentPickNumber: 1,
    roundFilter: 1,
    draftOrder: [

    ],
    selectedPlayers: [
        //{playerId, pickedBy, roundSelected}
    ],
};

//return { type: actionTypes.nextPick, nextPickNumber, nextRound, selectedPlayer };

export const statusReducer = function(state, action){
    switch(action.type){
        case statusActionTypes.setStep:
            return {...state, step: action.stepNumber}
        case statusActionTypes.startDraft:
            return {...state, step: state.step + 1, running: true, draftOrder: action.draftOrder}
        case statusActionTypes.pickPlayer:
            return {
                ...state,
                currentPickNumber: state.currentPickNumber + 1,
                selectedPlayers: [...state.selectedPlayers, {...action.selectedPlayer} ],
                running: !action.draftFinished,
                roundFilter: action.nextRound,
            }
        case statusActionTypes.setRoundFilter:
                return {...state, roundFilter: action.round}
        case statusActionTypes.restartDraft:
            return {...statusInitialState}
        default:
            return state;
    }
}

//Have teams grouped by year

const processTeamData = (year) => teamData[year].map(({name,code}) => ({name, code, logo: getTeamLogo(code)}));

const teamsInitialState = {
    data: processTeamData('2025'),
};

export const teamsReducer = function(state, action){
    switch(action.type){
        case optionsActionTypes.setDraftYear:
            return {
                data: processTeamData(action.year)
            }
        case statusActionTypes.restartDraft:
            return {...teamsInitialState}
        default:
            return state;
    }
}

const playersInitialState = {
    data: [],
    loading: false,
};

export const playersReducer = function(state, action){
    switch(action.type){
        case statusActionTypes.startDraft:
            return {...state, loading: true};
        case playersActionTypes.fetchSuccess:
            return {...state, data: action.payload, loading: false};
        case playersActionTypes.fetchError:
            return {...state, data: action.payload, loading: false, error: action.error};
        case statusActionTypes.restartDraft:
            return {...playersInitialState}
        default:
            return state;
    }
}

const modalInitialState = {
    isOpen: false,
};

export const modalReducer = function(state, action){
    switch(action.type){
        case modalActionTypes.setModalOpen:
            return {...state, isOpen: true};
        case modalActionTypes.setModalClose:
            return {...state, isOpen: false};
        default:
            return state;
    }
}

const roundPickRangesState = {
    data: [
        { start: 1, end: 32 },     // Round 1
        { start: 33, end: 64 },    // Round 2
        { start: 65, end: 96 },    // Round 3
        { start: 97, end: 128 },   // Round 4
        { start: 129, end: 160 },  // Round 5
        { start: 161, end: 192 },  // Round 6
        { start: 193, end: 224 }   // Round 7
    ]
}

export const roundPickRangesReducer = function(state, action){
    return state;
}

export const draftReducer = combineReducers({
    options: [optionsReducer, optionsInitialState],
    status: [statusReducer, statusInitialState],
    teams: [teamsReducer, teamsInitialState],
    players: [playersReducer, playersInitialState],
    modal: [modalReducer, modalInitialState],
    roundPick: [roundPickRangesReducer, roundPickRangesState],
});

